import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListShippingRates from "../../../../components/@shipping/shipping_rates/ListShippingRates";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ShippingRatesPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListShippingRates
                routeType={routeType}
            />
        </SettingFrame>
    )
}       